import React, { Component } from "react";
import NavbarBrand from "./navbarBrand";
import MainCarousel from "./mainCarousel";
import AboutSection from "./aboutSection";
import Portfolio from "./portfolioSection";
import ContactSection from "./contactSection";
import Footer from "./footer";
class Home extends Component {
  state = {};
  render() {
    return (
      <div>
        <div>
          <NavbarBrand />
        </div>
        <div>
          <MainCarousel />
        </div>
        <div>
          <Portfolio />
        </div>
        <div>
          <AboutSection />
        </div>
        <div>
          <ContactSection />
        </div>
        <div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default Home;
